import { CredentialUpload } from "@shared/components";

import * as styles from "./UploadCredentials.styles";

interface Props {
  isStudent: boolean;
  credentialsErrors?: any;
  handleSetCredentials: any;
  isDisabled: boolean;
}

const UploadCredentials = ({
  isStudent,
  credentialsErrors,
  handleSetCredentials,
  isDisabled,
}: Props) => {
  const renderErrors = () => {
    if (!credentialsErrors) {
      return null;
    }

    if (credentialsErrors.message) {
      return <p css={styles.error}>{credentialsErrors.message}</p>;
    }

    if (credentialsErrors.fields) {
      return credentialsErrors.fields.certificate.slice(0, 2).map(error => {
        return (
          <p css={styles.error} key={error}>
            {error}
          </p>
        );
      });
    }
  };

  return (
    <>
      <CredentialUpload
        isStudent={isStudent}
        uploadedFileHandler={files => handleSetCredentials(files)}
        isDisabled={isDisabled}
      />
      {renderErrors()}
    </>
  );
};

export { UploadCredentials };
